import {IBusinessObject} from "./PA.Core.IF.BO";
import {ISearch} from "../PA.UIM.Core/PA.UIM.Core.IF.Search";
import * as _ from "lodash"

interface IRegistry {
    dctBusinessObjectById: { [BOid: string]: { id: string, name: string, class: new (options?: any) => IBusinessObject } },
    dctSearchesByBusinessObjectId: { [BOid: string]: { id: string, name: string, search: ISearch }[] },
    dctUIFunctionsByBusinessObjectId: { [BOid: string]: { id: string, name: string, wizardFunction: (() => Promise<any>) }[] },
}


export class PAEnvironment {
    public static Network_URL_Base: string = "network.URL_Base";
    public static DBContext: string = "DbContext";
    public static UserContext: string = "Session.UsrContext";
    public static SessionContext: string = "Session.Context";
    public static UserLoginError: string = "Session.LoginError";
    public static UIAppManagerRegistry: string = "UI.AppManagerRegistry";
    public static UIAppSessionDefaultRender: string = "UI.AppSessionRendererDefault";
    public static UIThemeIdDefault: string = "UI.ThemeDefault"
    public static UIThemeId: string = "UI.ThemeCurrent"
    public static UICompact: string = "UI.Compact"
    public static UICompactDefault: string = "UI.CompactDefault"
    public static SSLOptions: string = "network.SSLOptions"
    public static UILauchPadVisible: string = "UI.LaunchPad"
    public static ESCustomColumns: string = "Session.ESCustomColumns"
    public static PostLoginURL: string = "Session.PostLoginURL"
    public static Database_RepositoryName: string = "database.RepositoryName"

    public static Registry: string = "registry"
    public static UIPlatformSession: string = "UI.PlatformSession";
    public static UIViewportFactory: string = "UI.ViewportFactory";


    public static io: string = 'io';
    public static LeaseServerURL: string = 'network.LeaseServerURL';

    public static WebSocketCreate: string = 'network.WebSocketCreate'

    public static SAPToken: string = 'Session.X-SAP-Logon-Token';

    public static AdapterUseHanaClient: string = "Adapter.UseHanaClient";
    public static AdapterHanaClientOpts: string = "Adapter.HanaClientOpts";

    static isNode(): boolean {
        // @ts-ignore
        return (typeof window === 'undefined');
    }

    static setValue(location: string, value: any) {
        var root: any;

        if (this.isNode())
            root = global;
        else { // @ts-ignore
            root = window;
        }

        if (!("PAEnvironmentState" in root))
            root.PAEnvironmentState = {};

        var currentObj = root.PAEnvironmentState;
        if (_.isEmpty(location)) return
        var parts = location.split('.');
        var len = parts.length;

        for (var i = 0; i < len; i++) {
            var prop_name = parts[i];
            if (i == (len - 1))
                currentObj[prop_name] = value;
            else {
                if (!(prop_name in currentObj))
                    currentObj[prop_name] = {};

                currentObj = currentObj[prop_name];
            }
        }


    }

    static getValue(location: string, defaultValue: any = null): any {
        var root: any;

        if (this.isNode()) {
            root = global;
        } else { // @ts-ignore
            root = window;
        }

        if (!("PAEnvironmentState" in root))
            root.PAEnvironmentState = {};

        var currentObj = root.PAEnvironmentState;
        var parts = location.split('.');
        var len = parts.length;

        for (var i = 0; i < len; i++) {
            var prop_name = parts[i];

            if (i == (len - 1)) {
                if (prop_name in currentObj)
                    return currentObj[prop_name];
                else
                    return defaultValue;
            } else {
                if (!(prop_name in currentObj))
                    return defaultValue;

                currentObj = currentObj[prop_name];
            }
        }

    }


    static getCurrentDateTs(bUseCachedDate?: boolean): Promise<Date> {

        return new Promise<Date>((resolve, error) => {
            // TODO: For now use the client date time stamp.. change to use server/ database
            resolve(new Date(Date.now()))
        });
    }

    private static getRegistry(): IRegistry {
        let returnValue: IRegistry = <any>PAEnvironment.getValue(PAEnvironment.Registry, undefined)

        if (_.isUndefined(returnValue) || _.isNull(returnValue)) {
            returnValue = {
                dctBusinessObjectById: {},
                dctSearchesByBusinessObjectId: {},
                dctUIFunctionsByBusinessObjectId: {}
            }
            PAEnvironment.setValue(PAEnvironment.Registry, returnValue)
        }

        return returnValue
    }

    static registerBusinessObjectClass(BusinessObjectClass: new (options?: any) => IBusinessObject, id: string, name: string) {
        //
        let registry = PAEnvironment.getRegistry()
        let BOid = id || BusinessObjectClass.name

        let BOname = name || BOid

        if (BOid in registry) {
            console.log(`${BOid} already registered.  Reregistering`)
        }

        registry.dctBusinessObjectById[BOid] = {id: BOid, name: BOname, class: BusinessObjectClass}

    }

    static getRegisteredBusinessObjectClasses(): { id: string, name: string, class: new (options?: any) => IBusinessObject }[] {
        let registry = PAEnvironment.getRegistry()
        return _.values(registry.dctBusinessObjectById)
    }

    static getRegisteredBusinessObjectClass(id: string): new (options?: any) => IBusinessObject {
        let registry = PAEnvironment.getRegistry()
        if (id in registry.dctBusinessObjectById) {
            let entry = registry.dctBusinessObjectById[id] || {}
            // @ts-ignore
            return entry.class
        }

        return undefined

    }


    static registerBusinessObjectSearch(BusinessObjectClass: (new (options?: any) => IBusinessObject) | string,
                                        searchId: string,
                                        search: ISearch,
                                        searchName?: string) {

        let registry = PAEnvironment.getRegistry()

        let BOid: string = <string>BusinessObjectClass
        if (!_.isString(BusinessObjectClass)) {
            if (_.isFunction(BusinessObjectClass)) {
                BOid = BusinessObjectClass.name
            }
        }

        if (!(BOid in registry.dctSearchesByBusinessObjectId)) {
            registry.dctSearchesByBusinessObjectId[BOid] = []
        }

        registry.dctSearchesByBusinessObjectId[BOid].push({id: searchId, name: searchName || searchId, search: search})
    }

    static getRegisteredBusinessObjectSearches(businessObjecClassId: string): { id: string, name: string, search: ISearch }[] {
        let registry = PAEnvironment.getRegistry()
        let BOid: string = <string>businessObjecClassId

        if (!(BOid in registry.dctSearchesByBusinessObjectId)) {
            return []
        }

        return _.values(registry.dctSearchesByBusinessObjectId[BOid])
    }

    static getRegisteredBusinessObjectSearch(businessObjectClassId: string, searchId: string): { id: string, name: string, search: ISearch } {
        let returnValue = undefined
        let registry = PAEnvironment.getRegistry()
        let BOid: string = <string>businessObjectClassId

        if (!(BOid in registry.dctSearchesByBusinessObjectId)) {
            return undefined
        }

        _.forEach(_.values(registry.dctSearchesByBusinessObjectId[BOid]), (anEntry) => {
            if (anEntry.id == searchId) {
                returnValue = anEntry
                return false // stop iterating
            }
        })

        return returnValue

    }

    static registerBusinessObjectUIWizard(businessObjectClassId: string, wizardFunctionId: string, wizardFunction: (() => Promise<any>), name?: string) {
        let registry = PAEnvironment.getRegistry()
        let BOid: string = <string>businessObjectClassId

        if (!(BOid in registry.dctUIFunctionsByBusinessObjectId)) {
            registry.dctUIFunctionsByBusinessObjectId[BOid] = []
        }
        let functionId = wizardFunctionId || name
        let functionName = name || functionId

        registry.dctUIFunctionsByBusinessObjectId[BOid].push({id: functionId, name: functionName, wizardFunction})

    }

    static getRegisteredBusinessObjectUIWizards(businessObjectClassId: string): { id: string, name: string, wizardFunction: (() => Promise<any>) }[] {
        let registry = PAEnvironment.getRegistry()
        let BOid: string = <string>businessObjectClassId

        if (!(BOid in registry.dctUIFunctionsByBusinessObjectId)) {
            return []
        }

        return _.values(registry.dctUIFunctionsByBusinessObjectId[BOid])

    }

    static getRegisteredBusinessObjectUIWizard(businessObjectClassId: string, functionId: string): () => Promise<any> {
        let returnValue = undefined
        let registry = PAEnvironment.getRegistry()
        let BOid: string = <string>businessObjectClassId

        if (!(BOid in registry.dctUIFunctionsByBusinessObjectId)) {
            return undefined
        }

        _.forEach(_.values(registry.dctUIFunctionsByBusinessObjectId[BOid]), (entry) => {
            if (entry.id == functionId) {
                returnValue = entry
                return false // stop iterating
            }
        })

        return returnValue
    }


}
